export default "__VITE_ASSET__CLzQ3Lig__"